import {
  IntegrationConnectionHealthStatus,
  IntegrationConnectionStatus,
} from 'src/api/generated';
import type { IntegrationConnectionUiStatus } from 'src/modules/shared/types/integration-connection-status.type';
import type { ComponentVariant } from 'src/modules/shared/types/component.type';
import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';

/**
 * Returns the visual tag variant for a connection status.
 */
export const getIntegrationStatusVariant = (
  status: IntegrationConnectionUiStatus
): ComponentVariant => {
  switch (status) {
    case IntegrationConnectionStatus.ACTIVE:
      return 'success';
    case IntegrationConnectionStatus.INACTIVE:
      return 'warning';
    case IntegrationConnectionStatus.ERROR:
      return 'danger';
    default:
      return 'neutral';
  }
};

/**
 * Returns the visual tag variant for a connection health status.
 */
export const getIntegrationHealthVariant = (
  status: IntegrationConnectionHealthStatus
): ComponentVariant => {
  switch (status) {
    case IntegrationConnectionHealthStatus.SYNCING:
      return 'info';
    case IntegrationConnectionHealthStatus.HEALTHY:
      return 'success';
    case IntegrationConnectionHealthStatus.PAUSED:
      return 'warning';
    case IntegrationConnectionHealthStatus.ERROR:
      return 'danger';
    default:
      return 'neutral';
  }
};

/**
 * Returns i18n key for a connection status label.
 */
export const getIntegrationStatusLabelKey = (
  status: IntegrationConnectionUiStatus
): TranslationKey => {
  switch (status) {
    case IntegrationConnectionStatus.ACTIVE:
      return 'settings.integrations.status.connected';
    case IntegrationConnectionStatus.INACTIVE:
      return 'settings.integrations.status.disabled';
    case IntegrationConnectionStatus.ERROR:
      return 'settings.integrations.status.error';
    default:
      return 'settings.integrations.status.disconnected';
  }
};

/**
 * Returns i18n key for a connection health label.
 */
export const getIntegrationHealthLabelKey = (
  status: IntegrationConnectionHealthStatus
): TranslationKey => {
  switch (status) {
    case IntegrationConnectionHealthStatus.SYNCING:
      return 'settings.integrations.health.syncing';
    case IntegrationConnectionHealthStatus.HEALTHY:
      return 'settings.integrations.health.healthy';
    case IntegrationConnectionHealthStatus.PAUSED:
      return 'settings.integrations.health.paused';
    case IntegrationConnectionHealthStatus.ERROR:
      return 'settings.integrations.health.error';
    default:
      return 'settings.integrations.health.healthy';
  }
};
